import React from 'react'
import TitleSection from '../TitleSection/TitleSection'
import './contact.css'
import BoxContact from './BoxContact/BoxContact'
import Form from './Form/Form'

export default function Contact() {
  return (
    <div className='contact' id='contactid'>
        <div className="container">
        <TitleSection title='إطلب الآن خدمة تصميم وبرمجة موقع إلكتروني' />
        <p className='p-importance'>اتصل بنا اليوم واحصل على استشارة مجانية!</p>
       <div className="row">
       <div className="col-lg-4 col-md-5 col-sm-12">
        <BoxContact />
        </div>
        <div className="col-lg-8 col-md-7 col-sm-12">
        <Form />
        </div>
       </div>
        </div>
    </div>
  )
}
